import { createAsyncThunk } from "@reduxjs/toolkit";
import { iGenericResponse,REDUCER_NAME ,iAddSuperAdminReachargedListItem} from "./Types";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { superAdminRecharged } from "@/services/api/cresivoxServer";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);
interface PurchaseOrderPayload {
  vendorId: string;
  amount: string;
}

export const addSuperAdminRecharged = createAsyncThunk<
// @ts-expect-error
  iGenericResponse<any | null> | null,
  PurchaseOrderPayload,
  // @ts-expect-error
  { rejectValue: iStateMessage }
>(
  "addSuperAdminRecharged",
  async (payload, { rejectWithValue }) => {
    // console.log("dkjbwhfgewhgfuew",payload)
    try {
      // ✅ Call service function instead of axios directly
      const response = await superAdminRecharged.addSuperAdminRecharged(payload);

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED: {
            if (data && data.data) {
              return {
                data: {
                  orders: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }

          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
 export const getSuperAdminRecharged = createAsyncThunk<
    // @ts-expect-error
  iGenericResponse<iAddSuperAdminReachargedListItem | null> | null,
>(
  curriedGetThunkName("getSuperAdminRecharged"),
  
  async (arg, {rejectWithValue}) => {
    try {
      
      const response = await superAdminRecharged.getSuperAdminRecharged();
      
      if (response) {
        const {httpStatusCode, data, message} = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
                // console.log("bfhjgfhegfwegfdghewcdghw",data.data)
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);
